import React from "react";
import { Accept, DropzoneOptions, useDropzone } from "react-dropzone";
import DnDOverlay, { DnDOverlayProps } from "./components/DnDOverlay";
import { isSafari } from "@clientUtils";
import { FileUploadConfig } from "@bonliva-crm/shared";

type Props = {
  className?: string;
  children?: React.ReactNode;
  render?: (data: { isActive: boolean; isAccepted: boolean }) => React.ReactNode;
  disabled?: boolean;
  onDrop: (files: File[]) => void;
  overlayProps?: Partial<DnDOverlayProps>;
  hideOverlay?: boolean;
  dropzoneOptions?: Partial<DropzoneOptions>;
  style?: React.CSSProperties;
  multiple?: boolean;
  noClick?: boolean;
  accept?: Accept;
};

const uploadConfig = new FileUploadConfig();

export const DnDLocalContainer: React.FC<Props> = (props) => {
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      return;
    }

    if (props.disabled) {
      return;
    }

    props.onDrop(acceptedFiles);
  };

  const accept = props.accept || uploadConfig.acceptTypes;
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    multiple: props.multiple,
    noClick: props.noClick,
    accept: props.accept || uploadConfig.acceptTypes,
    ...props.dropzoneOptions
  });

  const isActive = !props.disabled && isDragActive;
  const isAccepted = isSafari() ? true : !isDragReject;

  const rootProps = getRootProps();

  return (
    <div
      {...rootProps}
      onClick={(ev) => {
        // custom onClick handler, otherwise Switch stops working...
        if (props.noClick) {
          return;
        }

        rootProps.onClick(ev);
      }}
      className={props.className}
      data-test="DnDContainer"
      style={{
        position: "relative",
        outline: "none",
        ...props.style
      }}
    >
      <input {...getInputProps()} />
      {isActive && !props.hideOverlay && (
        <DnDOverlay
          {...props.overlayProps}
          accept={accept}
          type={isAccepted ? "accept" : "reject"}
        />
      )}
      {props.render?.({ isActive, isAccepted }) || props.children}
    </div>
  );
};

export default DnDLocalContainer;
